/* eslint-disable no-await-in-loop */
import axios from 'axios';

export default {
  state: {
    isConnect: false,
    isInstallRuntime: false,
    websocket: null,
    // successStep: 0,
  },
  connect() {
    this.state.websocket = new WebSocket('ws://127.0.0.1:45658/vmxinstall');
    this.state.websocket.binaryType = 'arraybuffer';
    this.state.websocket.onopen = () => {
      this.state.isConnect = true;
      // this.state.successStep = 0;
      console.log('socket connected...');
    };

    this.state.websocket.onclose = () => {
      this.state.isConnect = false;
      console.log('socket close...');
      // setTimeout(() => { this.connect(); }, 3000);
    };

    // this.state.websocket.onmessage = (event) => {
    //   if (event.data === 'succeed' && this.state.successStep < 3) {
    //     this.state.successStep += 1;
    //   }
    // };

    axios({ url: 'https://host.docker.internal:44566/v1/Signin', method: 'POST', data: { Username: 'Admin2', Password: 'Admin2' } })
      .then(() => { this.state.isInstallRuntime = true; }).catch(() => {
        console.log('Fail to start runtime');
        this.state.isInstallRuntime = false;
      });
  },
  isConnect() {
    return this.state.isConnect;
  },
  isInstallRuntime() {
    return this.state.isInstallRuntime;
  },
  // check(ms) {
  //   return new Promise(((resolve) => {
  //     const wsDelay = (sec) => {
  //       setTimeout(() => {
  //         if (this.state.successStep >= 3) {
  //           resolve('ok');
  //           return;
  //         }
  //         wsDelay(ms);
  //       }, sec);
  //     };
  //     wsDelay(ms);
  //   }));
  // },
  async install(obj) {
    /* return new Promise((resolve, reject) => {
      fetch(obj.firmware, {
        method: 'GET', mode: 'cors', cache: 'no-cache', headers: { Origin: '*' },
      }).then((res) => {
        res.blob().then(async (blob) => {
          let successCnt = 0;
          this.state.websocket.onmessage = (event) => {
            if (event.data === 'failed') reject(new Error('failed'));
            successCnt += 1;
            if (successCnt >= 3) resolve('ok');
          };
          await this.state.websocket.send(obj.id);
          await this.state.websocket.send(obj.md5);
          await this.state.websocket.send(blob);
        }).catch((err) => reject(err));
      }).catch((err) => reject(err));
    }); */
    /// //////////////
    // const CHUNK_SIZE = 1024 * 1024 * 10;
    // const response = await fetch(obj.firmware);
    // const contentRange = response.headers.get('content-range');
    // const fileSize = contentRange ? Number(contentRange.split('/')[1]) : response.headers.get('content-length');
    // const fileStream = [];
    // let offset = 0;
    let successCnt = 0;
    // while (offset < fileSize) {
    //   console.log(`${Math.round((offset / fileSize) * 100)}%`);
    //   const end = Math.min(offset + CHUNK_SIZE, fileSize);
    //   const options = { headers: { Range: `bytes=${offset}-${end - 1}` } };
    //   const blob = await fetch(obj.firmware, options).then((res) => res.blob());
    //   fileStream.push(blob);
    //   offset = end;
    // }
    // const blob = new Blob(fileStream, { type: response.headers.get('content-type') });
    await this.state.websocket.send(obj.id);
    await this.state.websocket.send(obj.md5);
    // await this.state.websocket.send(blob); // [download]
    const blob = new Blob(['0'], { type: 'application/zip' }); // [download]
    this.state.websocket.send(blob); // [download]

    return new Promise((resolve, reject) => {
      this.state.websocket.onmessage = (event) => {
        // console.log(event.data);
        if (event.data === 'failed') {
          console.log(event.data);
          reject(new Error('failed'));
          return;
        }
        successCnt += 1;
        if (successCnt >= 3) resolve('ok');
        console.log(successCnt);
      };
    });
  },
};
